import * as THREE from 'three';

export const SOURCE_TO_METRES = 0.0254;

export function sourceToThree(position = {}) {
  const x = Number(position.x || 0) * SOURCE_TO_METRES;
  const y = Number(position.z || 0) * SOURCE_TO_METRES;
  const z = -Number(position.y || 0) * SOURCE_TO_METRES;
  return new THREE.Vector3(x, y, z);
}

export function parseAwmh(arrayBuffer) {
  const view = new DataView(arrayBuffer);
  const magic = String.fromCharCode(...new Uint8Array(arrayBuffer, 0, 4));
  if (magic !== 'AWMH') throw new Error('CS2RADAR-MAP-101: AWMH magic mismatch');
  const version = view.getUint32(4, true);
  const vertexCount = view.getUint32(8, true);
  const triangleCount = view.getUint32(12, true);
  const vertexBytes = vertexCount * 3 * 4;
  const indexBytes = triangleCount * 3 * 4;
  if (version !== 1 || arrayBuffer.byteLength !== 16 + vertexBytes + indexBytes) {
    throw new Error('CS2RADAR-MAP-102: AWMH layout mismatch');
  }

  const geometry = new THREE.BufferGeometry();
  geometry.setAttribute(
    'position',
    new THREE.BufferAttribute(new Float32Array(arrayBuffer, 16, vertexCount * 3), 3),
  );
  geometry.setIndex(
    new THREE.BufferAttribute(new Uint32Array(arrayBuffer, 16 + vertexBytes, triangleCount * 3), 1),
  );
  geometry.computeVertexNormals();
  geometry.computeBoundingBox();
  geometry.computeBoundingSphere();
  return { geometry, version, vertexCount, triangleCount };
}
